
import { useState } from "react";
import { Button, Card, CardBody, Col, FormGroup, Input, Label, Row } from "reactstrap";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ImageDropZonePreview } from "../../globals/core/ImageDropZonePreview/ImageDropZonePreview";

export const EditUserForm = (props) => {

    const { handleAction, user } = props;

    const gOptions = [
        {
            value: "other",
            label: "Other"
        },
        {
            value: "female",
            label: "Female"
        },
        {
            value: "male",
            label: "Male"
        }
    ]

    const lOptions = [
        {
            value: "eng",
            label: "English"
        },
        {
            value: "heb",
            label: "Hebrew"
        }
    ]

    const initialState = {
        fullName: user?.fullName,
        email: user?.email,
        phone: user?.phone,
        gender: user?.gender,
        birthDate: user?.birthDate,
        region: user?.region,
        language: user?.language,
        title: user?.title,
        image: user?.image,
        selectedFiles: []
    }
    const [state, setState] = useState(initialState)

    const handleDropZone = ({ selectedFiles }) => {
        const lastFile = selectedFiles.pop();
        setState({ ...state, selectedFiles: [lastFile], image: lastFile });
    };

    const handleForm = (prop) => {
        setState({
            ...state,
            ...prop
        })
    }

    const renderForm = () => {
        return (
            <Card>
                <CardBody>
                    <div className="row">
                        <div className="px-2">
                            <Row className="mt-3">
                                <Col className="px-2 col-12 col-md-5">
                                    <FormGroup className="mb-3 mt-3 mt-lg-0">
                                        <h5 className="mt-4"> <Label htmlFor="_name">Full Name</Label></h5>
                                        <Input
                                            value={state.fullName}
                                            onChange={(e) => handleForm({ fullName: e.target.value })}
                                            type="text"
                                            id="_name">
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col className="px-2 col-12 col-md-5">
                                    <FormGroup className="mb-3 mt-3 mt-lg-0">
                                        <h5 className="mt-4"> <Label htmlFor="_email">Email</Label></h5>
                                        <Input
                                            value={state.email}
                                            onChange={(e) => handleForm({ email: e.target.value })}
                                            type="text"
                                            id="_email">
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col className="px-2 col-12 col-md-5">
                                    <FormGroup className="mb-3 mt-3 mt-lg-0">
                                        <h5 className="mt-4"> <Label htmlFor="_phone">Phone</Label></h5>
                                        <Input
                                            value={state.phone}
                                            onChange={(e) => handleForm({ phone: e.target.value })}
                                            type="text"
                                            id="_phone">
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col className="px-2 col-12 col-md-5">
                                    <FormGroup className="mb-3 mt-3 mt-lg-0">
                                        <h5 className="mt-4"> <Label htmlFor="_gender">Gender</Label></h5>
                                        <div className="mb-3 select2-container">
                                            <Select
                                                value={gOptions.find(o => o.value === state.gender)}
                                                onChange={(s) => {
                                                    handleForm({ gender: s.value });
                                                }}
                                                options={gOptions}
                                                classNamePrefix="select2-selection"
                                                id="_gender"
                                            />
                                        </div>
                                    </FormGroup>
                                </Col>
                                <Col className="px-2 col-12 col-md-5">
                                    <FormGroup className="mb-3 mt-3 mt-lg-0">
                                        <h5 className="mt-4"> <Label htmlFor="_birthdate">Bithdate</Label></h5>
                                        <DatePicker className="form-control" selected={new Date(state.birthDate).getTime()} onChange={(date) => handleForm({ birthDate: date })} />
                                    </FormGroup>
                                </Col>
                                <Col className="px-2 col-12 col-md-5">
                                    <FormGroup className="mb-3 mt-3 mt-lg-0">
                                        <h5 className="mt-4"> <Label htmlFor="_region">Region</Label></h5>
                                        <Input
                                            value={state.region}
                                            onChange={(e) => handleForm({ region: e.target.value })}
                                            type="text"
                                            id="_region">
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col className="px-2 col-12 col-md-5">
                                    <FormGroup className="mb-3 mt-3 mt-lg-0">
                                        <h5 className="mt-4"> <Label htmlFor="_language">Language</Label></h5>
                                        <div className="mb-3 select2-container">
                                            <Select
                                                id="_language"
                                                value={lOptions.find(o => o.value === state.language)}
                                                onChange={(s) => {
                                                    handleForm({ language: s.value });
                                                }}
                                                options={lOptions}
                                                classNamePrefix="select2-selection"
                                            />
                                        </div>
                                    </FormGroup>
                                </Col>
                                <Col className="px-2 col-12 col-md-5">
                                    <FormGroup className="mb-3 mt-3 mt-lg-0">
                                        <h5 className="mt-4"> <Label htmlFor="_title">Title</Label></h5>
                                        <Input
                                            value={state.title}
                                            onChange={(e) => handleForm({ region: e.target.value })}
                                            type="text"
                                            id="_title">
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col className="px-2 col-12 col-md-5">
                                    <FormGroup className="mb-3 mt-3 mt-lg-0">
                                        <h5 className="mt-4"> <Label htmlFor="_image">Image</Label></h5>
                                        <ImageDropZonePreview
                                            onChange={handleDropZone}
                                            selectedFiles={state.selectedFiles}
                                            accept="image/png, image/gif, image/jpeg"
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </CardBody>
            </Card>
        )
    }

    return (
        <div className="container">
            <div className="row my-3">
                <h3>Edit User</h3>
            </div>
            <div className="row my-2">
                {renderForm()}
            </div>
            <div className="row">
                <div className="d-flex justify-content-end">
                    <Button onClick={() => handleAction(state)} color={"success"}>Save User</Button>
                </div>
            </div>
        </div>
    )
}